import {  generateSectionExport } from './exportUtils';
import { recordingConfirmedMessage } from '../globals';

// Normalize exports to array format (handles string, array, or undefined)
const normalizeExports = (exports) => {
    if (!exports) return [];
    if (Array.isArray(exports)) return exports;
    if (typeof exports === 'string') {
        // Handle legacy string values
        if (exports === 'both') return ['doctor', 'patient'];
        if (exports === 'none') return [];
        return [exports];
    }
    return [];
};

export const documentExport = (documentData, documentType, dataHistory) => {
    const exports = {};

    documentType.sections.forEach(section => {
        const sectionExports = normalizeExports(section.exports);
        if (sectionExports.length > 0) {
            sectionExports.forEach(exportType => {
                if (!exports[exportType]) {
                    exports[exportType] = {};
                }
                const sectionExport = generateSectionExport(section, documentData, dataHistory);
                if (sectionExport) {
                    Object.assign(exports[exportType], sectionExport);
                }
            });
        }
    });

    // Always append the disclaimer to each export type
    Object.keys(exports).forEach(exportType => {
        exports[exportType].disclaimer = {
            data: `<p><i>${recordingConfirmedMessage}</i></p>`,
            title: '',
        };
    });

    return exports;
};